import { render, staticRenderFns } from "./RegisterWebinarParticipantDialog.vue?vue&type=template&id=61ef6064"
import script from "./RegisterWebinarParticipantDialog.vue?vue&type=script&lang=ts"
export * from "./RegisterWebinarParticipantDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports